import { LoadingItem } from '@core/loaders';
import { useTableContext } from '@core/table/features/TableContext';

import getProgressiveLoaderCss, {
  classes,
} from './styles/getProgressiveLoaderCss';

const ProgressiveLoader = () => {
  const { status } = useTableContext();

  if (status === 'progressing') {
    return (
      <div css={getProgressiveLoaderCss}>
        <div className={classes.loadingItemWrapper}>
          <LoadingItem className={classes.loadingItem} />
        </div>
      </div>
    );
  }

  return null;
};

export default ProgressiveLoader;
